<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
        doctorId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.vm.doctorId = this.doctorId;

        this.$store.dispatch("lookups/getLookups");

        this.$store
            .dispatch("patientsProcedures/getForEdit",{ id: this.itemId, doctorId: this.doctorId })

            .then((res) => {
                this.patient = res;
                this.vm.diseases= res.diseases;
                this.vm.skinIssues= res.skinIssues;
            }).catch(() => { });
    },
    computed: {
        diseasesTypes() {
            return this.$store.getters["lookups/getLookupByType"](
                this.$lookupTypes.DiseasesTypes
            );
        },
        skinIssuesTypes() {
            return this.$store.getters["lookups/getLookupByType"](
                this.$lookupTypes.SkinIssuesTypes
            );
        },
    },
    data() {
        return {
            patient: {
                fullName: null,
                fileNo: null,
                gender: null,
                birthDate: null,
                bloodType: null,
            },
            vm: {
                doctorId: null,
                diseases: [],
                skinIssues: []
            },
        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("patientsProcedures/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        allowedDates(val) {
            const today = new Date();
            today.setFullYear(today.getFullYear() - 15);
            const date = new Date(val);
            return date < today;
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>